
<div class="max-page-width">
  <div *ngFor="let item of HomeMiddleContent" >    
    <div [innerHTML]="item.contentText | translate"></div>
  </div> 
</div>